module.exports = __webpack_public_path__ + "media/images/application/template/select-arrow-down-4c4549a475ce25f3f2deb7e205940a28.svg";